import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { useStore } from '../../stores/store';
import { Button, Form, Grid, Header, Modal } from 'semantic-ui-react';
import { ResolveComment } from '../../models/ResolveComment';
import { v4 as uuid } from 'uuid';
import { RejectionComment } from '../../models/RejectionComment';
import AlertsMoveToOptions from '../../../features/Messages/AlertsMoveToOptions';
import { WorkFlowTemplate } from './../../models/template';

function MediaAssetResolveModal({
  selectedSubTaskId,
  submitHandler,
  smartTracker,
  closeHandler,
}: {
  selectedSubTaskId?: string;
  submitHandler?: (resolveData: {
    resolveId: string;
    resolveName: string;
  }) => void;
  smartTracker?: boolean;
  closeHandler?: () => void;
}) {
  const [, setOpen] = useState(false);
  const { mediaAssetStore, userStore, activityStore, ElementStore } =
    useStore();
  const { getResolveId, triggerResolve } = ElementStore;
  const [value, setValue] = useState('');
  const [, setResolve] = useState<ResolveComment[] | undefined>();
  const [rejectionCommentData, setRejectionCommentData] = useState<
    RejectionComment | undefined
  >();
  const [templateArray, setTemplateArray] = useState<WorkFlowTemplate>();
  const [subtaskIndexState, setSubtaskIndexState] = useState(0);
  const [taskIndexState, setTaskIndexState] = useState(0);

  const { rejectionStore } = useStore();
  const {
    selectedRejection: reject,
    rejectionRegistry,
    loadRejections,
  } = rejectionStore;
  useEffect(() => {
    if (rejectionRegistry.size <= 1) loadRejections();

    setRejectionCommentData(reject);
    setResolve(reject?.resolve);
  }, [rejectionRegistry.size, loadRejections, reject]);

  const closeMediaAssetResolveModal = () => {
    closeHandler?.();
    mediaAssetStore.setResolveComments(value);
    mediaAssetStore.mediaAsset.redirectOpenResolved = false;
    mediaAssetStore.mediaAsset.resolveValueSelected = false;
  };

  const handleFormSubmit = () => {
    if (templateArray && activityStore.selectedActivity) {
      templateArray.tasks.forEach((task) => {
        if (task.taskIndex === taskIndexState) {
          task.status = 'started';
          task.isCurrentTask = true;
          task.subTasks.forEach((subtask) => {
            if (subtask.subtaskIndex === subtaskIndexState) {
              subtask.status = 0;
              subtask.isCurrentSubtask = true;
            } else if (subtask.subtaskIndex > subtaskIndexState) {
              subtask.status = 0;
              subtask.isCurrentSubtask = false;
            } else {
              // subtask.status=7
              subtask.isCurrentSubtask = false;
            }
          });
        } else if (task.taskIndex > taskIndexState) {
          task.status = '';
          task.isCurrentTask = false;
          task.subTasks.forEach((subtask) => {
            subtask.status = 0;
            subtask.isCurrentSubtask = false;
          });
        } else {
          // task.status="completed";
          task.isCurrentTask = false;
          task.subTasks.forEach((subtask) => {
            // subtask.status=7
            subtask.isCurrentSubtask = false;
          });
        }
        if (task.taskName === rejectionCommentData?.task) {
          //for resolve

          task.subTasks.forEach((subtask) => {
            if (subtask.subTaskName === rejectionCommentData.subtask) {
              subtask.status = 0;
              subtask.isCurrentSubtask = false;
            }
          });
        }
      });
      if (rejectionCommentData !== undefined && !smartTracker) {
        const ResolveArr = {
          ...rejectionCommentData,
          resolve: [
            {
              id: uuid(),
              itemID: reject?.id,
              resolveDateTime: activityStore.updateDateTime(),
              username:
                userStore.user?.displayName !== undefined
                  ? userStore.user?.displayName
                  : '',
              resolveMessage: value,
            },
          ],
        };
        rejectionStore.updateReject(ResolveArr);
      }
      triggerResolve(getResolveId);
      closeMediaAssetResolveModal();
      submitHandler?.({
        resolveId: getResolveId.id?.split('|')?.[0] || '',
        resolveName: getResolveId?.name || '',
      });
    }
  };

  return (
    <Modal
      onClose={() => {
        closeHandler?.();
        setOpen(false);
      }}
      onOpen={() => setOpen(true)}
      open={mediaAssetStore.mediaAsset.resolveValueSelected}
    >
      <Modal.Header>Resolve</Modal.Header>
      <Modal.Content>
        <Modal.Description>
          <Grid.Column style={{ width: '100%' }}>
            <Form>
              <Form.TextArea
                label="Resolution Comment"
                placeholder="Comment"
                value={value}
                onChange={(e) => setValue(e.currentTarget.value)}
              />
              <Header as="h5" style={{ marginBottom: '1px' }}>
                Move to
              </Header>
              <AlertsMoveToOptions
                selectedSubTaskId={selectedSubTaskId || ''}
                setTemplateArray={setTemplateArray}
                setSubtaskIndexState={setSubtaskIndexState}
                setTaskIndexState={setTaskIndexState}
              />
            </Form>
          </Grid.Column>
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button color="black" onClick={closeMediaAssetResolveModal}>
          Cancel
        </Button>
        <Button
          content="Save"
          labelPosition="right"
          icon="checkmark"
          onClick={handleFormSubmit}
          positive
        />
      </Modal.Actions>
    </Modal>
  );
}

export default observer(MediaAssetResolveModal);
